var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChronometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 13",
    fill: "#fff",
    stroke: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_chronometer_path1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.967 0v1.054h1.088v.527a3.75 3.75 0 0 1 1.089 0v-.527h1.088V0H3.967Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.457,
    r: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.3 3.48.38-.37.436.422.762-.738-1.633-1.581-.762.738.436.421-.49.475c-2.612-1.529 2.775 2.319.87.632Zm-3.783.15C7.6 3.63 9.29 5.268 9.29 7.285H5.517V3.631Z",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_chronometer_path1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h11v12.956H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChronometer);
export default __webpack_public_path__ + "static/media/icon_chronometer.5fccffe59b6f697b20c210c15b175625.svg";
export { ForwardRef as ReactComponent };